/**
 * 筛选面板组件
 * 提供基于枚举列的数据筛选功能
 */
import React from 'react';
import { Card, Checkbox, Space, Tag, Button, Typography } from 'antd';
import { FilterOutlined, ClearOutlined } from '@ant-design/icons';

const { Text } = Typography;

const FilterPanel = ({ columns, filters, onFilterChange, onClearFilters }) => {
  // 只显示最后一列（标签列）的筛选选项
  // 标签列通常是最后一列，且是枚举类型
  const labelColumn = columns.length > 0 ? columns[columns.length - 1] : null;
  const enumColumns = labelColumn && labelColumn.type === 'enum' && labelColumn.enum_values
    ? [labelColumn]
    : [];

  if (enumColumns.length === 0) {
    return null; // 没有可筛选的列
  }

  return (
    <Card
      size="small"
      title={
        <Space>
          <FilterOutlined />
          <span>数据筛选</span>
        </Space>
      }
      extra={
        <Button
          size="small"
          icon={<ClearOutlined />}
          onClick={onClearFilters}
        >
          清除筛选
        </Button>
      }
      style={{ marginBottom: 16 }}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        {enumColumns.map(column => (
          <div key={column.key}>
            <Text strong style={{ display: 'block', marginBottom: 8 }}>
              {column.title}:
            </Text>
            <Checkbox.Group
              value={filters[column.key] || []}
              onChange={(values) => onFilterChange(column.key, values)}
            >
              <Space wrap>
                {column.enum_values.map(value => (
                  <Checkbox key={value} value={value}>
                    <Tag>{value}</Tag>
                  </Checkbox>
                ))}
              </Space>
            </Checkbox.Group>
          </div>
        ))}
      </Space>
    </Card>
  );
};

export default FilterPanel;

